import React, { Component } from "react";
import { GridContainerFlex } from "../../layout/GridFlex/GridContainerFlex/GridContainerFlex.jsx";
import { GridItemFlex } from "../../layout/GridFlex/GridItemFlex/GridItemFlex.jsx";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({ error });
        console.error(error);
    }

    render() {
        const { hasError } = this.state;
        const { fallback, children } = this.props;

        if (hasError) {
            if (import.meta.env.MODE === "development") {
                return (
                    <GridContainerFlex justifyContent="center">
                        <GridItemFlex>
                            <div style={{ textAlign: "center", color: "#d32f2f", padding: "2rem" }}>
                                <h2>🚨 An error occurred.</h2>
                                <p>Please check the browser console for more details.</p>
                            </div>
                        </GridItemFlex>
                    </GridContainerFlex>
                );
            }

            return fallback || (
                <GridContainerFlex justifyContent="center">
                    <GridItemFlex>
                        <div style={{ textAlign: "center" }}>
                            <h2>Something went wrong.</h2>
                            <p>Please try refreshing the page or contact support if the problem persists.</p>
                        </div>
                    </GridItemFlex>
                </GridContainerFlex>
            );
        }

        return children;
    }
}

export default ErrorBoundary;
